import gql from "graphql-tag"

export const validationErrorFragment = gql`
  fragment ValidationErrorFragment on ValidationError {
    path
    message
  }
`
